import { render } from "./LobbyView.vue?vue&type=template&id=8b9c1824&scoped=true"
import script from "./LobbyView.vue?vue&type=script&lang=js"
export * from "./LobbyView.vue?vue&type=script&lang=js"

import "./LobbyView.vue?vue&type=style&index=0&id=8b9c1824&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9c1824"]])

export default __exports__